import { Directive, Input, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: '[appCopy]'
})
export class CopyClipboardDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('click', ['$event'])
  public onClick(event: Event) {
    // Create an auxiliary hidden input
    const aux = document.createElement('input');

    // Get the text from element
    const text = this._el.nativeElement.innerHTML;

    // Assign it the value from the div
    aux.setAttribute('value', text);

    // Append the aux input to the body
    document.body.appendChild(aux);

    // Highlight the content
    aux.select();

    // Copy the highlighted text
    document.execCommand('copy');

    // Remove the input from the body after copy text
    document.body.removeChild(aux);
  }
}